import {AlertIcon, PlusIcon} from '@primer/octicons-react'
import {Button} from '@primer/react'
import {forwardRef} from 'react'

import styles from './AddIssueFieldButton.module.css'

export const AddIssueFieldButton = forwardRef<
  HTMLButtonElement,
  {
    anchorProps?: React.HTMLAttributes<HTMLElement> | undefined
    /// True if button should appear inactive with alert icon
    inactive?: boolean | undefined
    /// True if button should not be actionable
    disabled?: boolean | undefined
    onClick: () => void
  }
>((props, ref) => {
  const {anchorProps, inactive = false, disabled = false, onClick} = props
  return (
    <div className={styles.container}>
      <Button
        leadingVisual={inactive ? AlertIcon : undefined}
        trailingVisual={!inactive ? PlusIcon : undefined}
        size="small"
        ref={ref}
        {...anchorProps}
        className={styles.button}
        inactive={inactive || disabled}
        onClick={event => {
          if (disabled) return
          onClick()
          anchorProps?.onClick?.(event)
        }}
      >
        Add field
      </Button>
    </div>
  )
})
AddIssueFieldButton.displayName = 'AddIssueFieldButton'
